import { gql } from "@apollo/client";

export const createPin = gql`
    mutation createPin($groupId: String, $organizationId: String = null) {
        selectedOrganization @client {
            id @export(as: "organizationId")
        }
        createPin(input: { groupId: $groupId, organizationId: $organizationId }) {
            groupId
        }
    }
`;
